import { ApplicationController } from './../application_controller'

export default class extends ApplicationController {
  applyDiscount(e) {
    let submitButton = this.element
    let form = submitButton.form
    var formData = new FormData(form)

    // Remove common form attributes that we don't need on the page refresh
    formData.delete(`authenticity_token`)
    formData.delete(`attendable_person_gid`)
    formData.delete(`cf-turnstile-response`)

    var redirectURL = new URL(submitButton.formAction)
    var newSearchParams = new URLSearchParams(formData)

    redirectURL.search = newSearchParams.toString()
    window.location.href = redirectURL.toString()

    Ladda.create(submitButton).start()
    e.preventDefault()
  }
}
